import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Header from './Header'
import ControlsBar from './ControlsBar'
import Interface from './Interface'
import SummarySection from './SummarySection'
import FAQSection from './FAQSection'
import Footer from '../../components/Footer'

export default function HomePage() {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    document.title = t('meta.title')
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) metaDesc.setAttribute('content', t('meta.description'))
  }, [t, i18n.language])

  return (
    <div className="min-h-screen font-sans selection:bg-neonPink selection:text-white">
      <Header />
      <main className="max-w-7xl mx-auto px-4 py-8">
        <ControlsBar />
        <Interface />
        <SummarySection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  )
}
